// extracted by mini-css-extract-plugin
export var header = "header-module--header--eORMa";
export var headerTransparent = "header-module--headerTransparent--buu8p";